import React from 'react';

export interface StatusViewsContextInterface {
  clientId: string;
  accountId: string;
}

export const StatusViewsContext = React.createContext<StatusViewsContextInterface>({
  clientId: '',
  accountId: '',
});
